import React, { ComponentProps, forwardRef, MouseEvent, MouseEventHandler, useCallback } from 'react'
import Step from './Step'
import StepConnector from './StepConnector'

type InheritedStepProps = Omit<ComponentProps<typeof Step>, 'onClick' | 'interactive'>

interface Props extends InheritedStepProps{
  stepIndex: number
  stepKey: string | number
  onClick?: ((key: string | number) => void) | ((key: string | number, event: MouseEvent<HTMLButtonElement>) => void)
}

const _StepperProgressStep = forwardRef<HTMLButtonElement, Props>(function _StepperProgressStep(props, ref) {
  const { stepIndex, stepKey, onClick, ...rest } = props
  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    onClick?.(stepKey, event)
  }, [onClick, stepKey])

  return <>
    {stepIndex !== 0 && <StepConnector />}
    <Step
      {...rest}
      ref={ref}
      interactive={!!onClick}
      onClick={handleClick}
    />
  </>
})

export default _StepperProgressStep
